/**
 * @summary Common Interval Hook
 * @author MonkeyFigaro <monkeychen@sohu-inc.com>
 *
 * Created at     : 2019-03-14 15:22:33
 * Last modified  : 2019-04-19 17:47:24
 */

import { useEffect, useRef } from 'react';

/**
 * @param  {any} callback
 * @param  {number=0} delay - Will refresh used ref when delay count changes
 */
export function useInterval(callback: any, delay: number = 0) {
    // tslint:disable-next-line
    const savedCallback = useRef(() => { });

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        const id = setInterval(tick, delay);
        return () => clearInterval(id);
    }, [delay]);
}



// WEBPACK FOOTER //
// ./src/hooks/useInterval.ts